export const COACH_KAI_OPEN_EVENT = "leadxkids:coach-kai-open";

export function openCoachKai() {
  window.dispatchEvent(new CustomEvent(COACH_KAI_OPEN_EVENT));
}